import React, { useLayoutEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet, Route, Routes } from 'react-router-dom';
import { Heading } from '@digitools/honest-react';
import { Breadcrumb, Breadcrumbs } from '@digitools/honest-ui';
import FilterMyReport from 'src/packages/createMyReport/components/filter-my-report/FilterMyReport';
import ReportFieldPage from 'src/packages/createMyReport/components/select-field-report/ReportFieldPage';
import ReportFieldDetailPage from 'src/packages/createMyReport/components/run-my-report/report-preview/ReportFieldDetailPage';
import MyReportFilterDetail from 'src/packages/createMyReport/components/run-my-report/report-preview/MyReportFilterDetail';
import { useHomePageBreadcrumbs } from 'src/components/Breadcrumbs';
import { resetCrsState } from 'src/packages/createMyReport/crsActions';
const Wrapper = ({ children }) => {
    return (<>
      <Heading style={{ marginTop: '20px' }}> Create my report </Heading>
      {children}
    </>);
};
const CreateMyReportRouter = () => {
    const dispatch = useDispatch();
    const homePageBreadcrumbs = useHomePageBreadcrumbs();
    const [hasResetCrsState, setHasResetCrsState] = useState(false);
    // Resets CRS data on load to avoid stale data.
    useLayoutEffect(() => {
        dispatch(resetCrsState());
        setHasResetCrsState(true);
    }, [dispatch]);
    // The report pages read the store on mount, so they must not render until the reset lands.
    if (!hasResetCrsState) {
        return null;
    }
    return (<>
      <Breadcrumbs>
        {homePageBreadcrumbs}
        <Breadcrumb>{'Create my report'}</Breadcrumb>
      </Breadcrumbs>
      <Wrapper>
        <Routes>
          <Route path={`report-field`} element={<ReportFieldPage />}/>
          <Route path={`run-my-report`} element={<Outlet />}>
            <Route index element={<>
                  <MyReportFilterDetail />
                  <ReportFieldDetailPage />
                </>}/>
          </Route>
          <Route path={`*`} element={<FilterMyReport />}/>
        </Routes>
      </Wrapper>
    </>);
};
export default CreateMyReportRouter;
